/* NS Rails — filas de tarjetas de producto (.ns-rail): "También te puede gustar" (ns-recommendations)
   y "Productos vistos recientemente" (ns-recently-viewed). Sustituye al slider y a las cargas por JS
   de XTRA (custom-async.js). Las tarjetas son siempre snippets/ns-product-card. */
(function () {
  'use strict';
  if (window.NSRails) return;
  window.NSRails = true;

  /* Misma clave y formato que usaba XTRA ([{productUrl, productId}], máx. 12): el historial se conserva. */
  var KEY = 'recentlyViewedProduct';
  var MAX = 12;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function html(text) { return new DOMParser().parseFromString(text, 'text/html'); }
  function getList() {
    try { var l = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(l) ? l : []; } catch (e) { return []; }
  }
  function setList(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} }

  /* La ficha (assets/ns-product.js / sections/ns-product.liquid) deja su id y su URL en el DOM. */
  function recordView() {
    var pdp = $('.ns-pdp'), j = $('[data-ns-product-json]');
    if (!pdp || !j) return;
    var id;
    try { id = String(JSON.parse(j.textContent).id); } catch (e) { return; }
    var list = getList().filter(function (x) { return String(x.productId) !== id; });
    list.push({ productUrl: pdp.dataset.productUrl, productId: id });
    setList(list.slice(-MAX));
  }

  /* Recomendados: Shopify los devuelve renderizando esta misma sección con ?intent=related. */
  function loadRecommended(el) {
    if (!el.hidden || !el.dataset.url) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) {
        var src = text && $('[data-ns-reco] [data-ns-rail]', html(text));
        if (!src || !src.children.length) return;
        $('[data-ns-rail]', el).innerHTML = src.innerHTML;
        el.hidden = false;
        updateNav(el);
      })
      .catch(function () {});
  }

  /* Vistos recientemente: una tarjeta por producto, pedida a la sección ns-product-item. */
  function loadRecent(el) {
    var n = parseInt(el.dataset.number, 10) || 5;
    var current = el.dataset.current;
    var items = getList().slice().reverse().filter(function (x) { return String(x.productId) !== current; }).slice(0, n + 2);
    if (!items.length) return;
    Promise.all(items.map(function (it) {
      return fetch(it.productUrl + '?section_id=ns-product-item')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (text) { return text ? $('.ns-pcard', html(text)) : null; })
        .catch(function () { return null; });
    })).then(function (cards) {
      cards = cards.filter(Boolean).slice(0, n);
      if (!cards.length) return;
      var ul = $('[data-ns-rail]', el);
      cards.forEach(function (c) { ul.appendChild(document.importNode(c, true)); });
      el.hidden = false;
      updateNav(el);
    });
  }

  /* Flechas (solo escritorio): se muestran si la fila tiene más tarjetas de las que caben. */
  function updateNav(sec) {
    var rail = $('[data-ns-rail]', sec), nav = $('[data-ns-rail-nav]', sec);
    if (rail && nav) nav.hidden = rail.scrollWidth <= rail.clientWidth + 2;
  }
  document.addEventListener('click', function (e) {
    var go = e.target.closest('[data-ns-rail-go]');
    if (!go) return;
    var rail = $('[data-ns-rail]', go.closest('.ns-rail-sec'));
    if (rail) rail.scrollBy({ left: Number(go.dataset.nsRailGo) * rail.clientWidth, behavior: 'smooth' });
  });
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { $$('.ns-rail-sec:not([hidden])').forEach(updateNav); }, 150);
  });

  function init() {
    recordView();
    $$('[data-ns-reco]').forEach(loadRecommended);
    $$('[data-ns-recent]').forEach(loadRecent);
    $$('.ns-rail-sec:not([hidden])').forEach(updateNav);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
